import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/subscription')({
  component: SubscriptionPage,
});
